import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useStyles } from "../../../pages/Settings/components/PlanDetail/const";
import styles from "./styles.module.scss";

export type PurchaseMode = "on-file" | "new";

type PaymentModeSelectorProps = {
  selectedMode: PurchaseMode | null;
  onSelect: (value: PurchaseMode) => void;
  purchasing: boolean;
};

export default function PaymentModeSelector(props: PaymentModeSelectorProps) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <RadioGroup
      className={styles.modeSelector}
      row
      defaultValue="on-file"
      value={props.selectedMode}
      onChange={e => props.onSelect(e?.target?.value === "on-file" ? "on-file" : "new")}
    >
      <FormControlLabel
        disabled={props.purchasing}
        value="on-file"
        control={
          <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={
              <span className={classnames(classes.icon, classes.checkedIcon)} />
            }
            icon={<span className={classes.icon} />}
          />
        }
        label={<span className={styles.paymentType}>{t("Common.Payment on File")}</span>}
      />
      <FormControlLabel
        value="new"
        control={
          <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={
              <span className={classnames(classes.icon, classes.checkedIcon)} />
            }
            icon={<span className={classes.icon} />}
          />
        }
        label={
          <span className={styles.paymentType}>{t("Common.addNewPaymentMethod")}</span>
        }
      />
    </RadioGroup>
  );
}
